module.exports = __webpack_public_path__ + "static/media/triangle.7eef1202.svg";